module.exports = __webpack_public_path__ + "img/430.6c976268.jpg";